export default __webpack_public_path__ + "static/media/signup-dude.727109b5.svg";